<template>
  <div v-if="open_forms_name.enable">
    <ListForms @close="close_list_form" :name="open_forms_name.name" :device_name="open_forms_name.device_name" :barcode_id="open_forms_name.barcode_id"/>
  </div>
  <div v-else>
    <div>
      <div class="tasks-title-box w-100 rounded">
        <v-row class="ma-5">
          <v-col class="my-auto mx-auto mobile-d-none"><h3>بارکد ها</h3></v-col>
          <v-col>
            <v-text-field label="جست و جو کنید"
                          placeholder="حداقل ۳ حرف "
                          dense outlined dir="ltr"
                          v-model="search_field"
                          class="search-tasks"
                          clearable
                          @click:clear="search_field=null;get_barcodes()"
                          @keydown.enter="page=1;get_barcodes()"
                          :rules="[rules.min_3]"
                          style="margin-bottom: -25px"
            >
              <template v-slot:append v-if="search_field && search_field.length>=3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="red" v-bind="attrs" v-on="on" @click="page=1;get_barcodes()"> mdi-magnify </v-icon>
                  </template>
                  <span>
                      برای جست و جو کلیک کنید.
                    </span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
          <v-col class="text-left">
            <v-btn
                class="elevation-0"
                @click="show_report_dialog=true;"
            >
              <v-icon>mdi-file-document</v-icon>
              <div>گزارش گیری</div>
            </v-btn>
          </v-col>
          <v-col class="text-left" xs="12">
            <v-btn large class="elevation-0" @click="add_barcode_dialog=true;">
              <v-icon small>mdi-plus</v-icon>
              <div class="mobile-d-none">افزودن</div>
            </v-btn>
          </v-col>
        </v-row>
      </div>
  </div>
    <div class="last-changes rounded-lg container">
      <h2 class="text-center mb-3">بارکد های ثبت شده</h2>
      <v-data-table
          dense
          hide-default-footer
          :loading="loading_barcodes"
          :headers="barcodes.headers"
          :items="barcodes.desserts"
          class="elevation-0"
      >
          <template v-slot:item.img="{ item }">
            <div class="pa-10 barcode-box">
              <v-img v-bind:src="`${item.img}`" width="145px" height="145px" class="mx-auto barcode">
              </v-img>
              <v-btn color="info" text class="ma-2" @click="download(`${BACKEND_LINK}/media/barcodes/qr_code_${item.id}.png`)">
                دانلود بارکد
              </v-btn>
            </div>
          </template>
          <template v-slot:item.created_at="{ item }">
            <v-tooltip top color="red">
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs"
                   v-on="on">
                  {{new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR')}}
                </a>
              </template>
              <span>{{ convert_en_to_fa_number(item.created_at.split('T')[1].split('.')[0]) }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.download="{ item }">
            <v-btn color="success" outlined @click="list_forms(item)">
              لیست فرم ها
            </v-btn>
          </template>
        <template v-slot:item.remove="{ item }">
          <v-btn color="error" outlined @click="remove.en=true;remove.form=item">
            حذف
          </v-btn>
        </template>
      </v-data-table>
      <div v-if="barcodes_count > 10" class="text-center mt-10">
        <v-pagination
            v-model="page"
            color="#D20003"
            rounded
            @input="get_barcodes()"
            :length="barcodes_count%10!==0?parseInt(barcodes_count/10)+1:parseInt(barcodes_count/10)"
            :total-visible="7"
        ></v-pagination>
      </div>
    </div>
    <v-dialog v-model="add_barcode_dialog" height="10vh" width="30em">
      <v-card>
        <v-card-title>افزودن بارکد</v-card-title>
        <v-card-text>
          <v-container>
            <v-select
                rounded outlined
                label="فرم"
                v-model="barcode_form.name"
                :rules="[rules.required]"
                :items="[
                    'کنترل هفتگی عملکرد سیستم های تاسیساتی',
                    'گزارش هفتگی کولر های گازی',
                    'کنترل کارکرد کولر گازی (PM)',
                    'گزارش هفتگی پکیج های برودتی',
                    'چک لیست کنترل کارکرد دستگاه',
                    'گزارش هفتگی تاسیسات برقی',
                    'کنترل کارکرد تاسیسات برقی (PM)',
                    'کنترل ماهیانه',
                    'كنترل عملكرد تابلو های برق',
                    'کنترل عملكرد تجهیزات حرارت مركزي',
                    'كنترل عملكرد تجهیزات جنبی سیستم حرارت مركزي',
                    'كنترل عملكرد تاسیسات',
                    'pm بازدید نگهداری موتورخانه ها'
                    ]"
            ></v-select>
            <v-text-field v-model="barcode_form.device_name"
                        rounded outlined
                        label="نام دستگاه"
            ></v-text-field>
            <v-btn color="success" :disabled="!barcode_form.name" @click="send_barcode">ثبت و دریافت بارکد</v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="remove.en"
        persistent
        max-width="600"
        class="br-1em"
    >
      <v-card class="br-1em">
        <v-card-title>
          <h4 class="mx-auto">
            آیا میخواهید بارکد '<i>{{ remove.form["name"] }}</i>' را حذف کنید ؟
          </h4>
        </v-card-title>
        <v-card-actions class="text-center pb-5">
          <v-spacer></v-spacer>

          <v-btn
              color="green"
              @click="remove.en = false"
              large text
              class="elevation-0"
          >
            بازگشت
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              class="elevation-0"
              :loading="remove.loading"
              @click="remove_barcode()"
          >
            حذف
          </v-btn>
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show_report_dialog"
              scrollable
              persistent
              max-width="600"
    >
      <v-card>
        <v-card-title class="mb-5 w-100">
          <v-switch
              label="همه"
              class="ml-10"
              v-model="report_form.is_all"
              inset
          ></v-switch>
          <h4 class="mr-15">
            دریافت گزارش خرید
          </h4>

          <v-spacer></v-spacer>
          <div
              @click="show_report_dialog=false"
          >
            <svg width="44" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="44" height="44" rx="22" class="back-btn"/>
              <path d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z" fill="black"/>
              <path d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z" fill="black"/>
            </svg>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row v-if="!report_form.is_all">
            <v-col cols="6">
              <v-combobox
                  v-model="report_form.barcode"
                  :items="barcodes.desserts"
                  item-text="device_name"
                  item-value="id"
                  outlined
                  style="border-radius: 5px "
                  label="دستگاه"
              ></v-combobox>
            </v-col>
            <v-col cols="6">
              <v-select
                  v-model="report_form.format"
                  :items="['PDF', 'CSV']"
                  outlined  style="border-radius: 5px "
                  label="انتخاب فرمت"
              ></v-select>
            </v-col>

            <v-col>
              <date-picker style="color: black"
                           class="my-5 mx-5"
                           :min="new Date().toLocaleDateString('en-IR')"
                           v-model="report_form.date"
                           large
                           range label="انتخاب تاریخ"
              ></date-picker>
            </v-col>

          </v-row>
          <v-select
              v-else
              v-model="report_form.format"
              :items="['PDF', 'CSV']"
              outlined  style="border-radius: 5px "
              label="انتخاب فرمت"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="green"
              class="mr-auto mb-1 ml-1"
              block
              @click="manage_download"
              :loading="report_form.download_btn_loading"
          >
            دانلود
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import axios from "axios";
import ListForms from "@/components/forms/list.vue";


export default {
  name: "HomeBarcode",
  components:{ListForms},
  created() {
    this.get_barcodes();
  },
  data:()=>({
    report_form:{
      is_all:false,
      download_btn_loading: false,
      format:"PDF",
      date:'',
    },
    remove:{
      en: false,
      form: {},
      loading: false
    },
    search_field: null,
    show_report_dialog:false,
    add_barcode_dialog:false,
    key: localStorage.getItem('key'),
    barcodes_count: 0,
    page:1,
    loading_barcodes:false,
    barcodes: {
      headers: [
        {text: 'نام',align: 'center', value: 'name'},
        {text: 'نام دستگاه',sortable: false,align: 'center', value: 'device_name'},
        {text: 'زمان ثبت',align: 'center', value: 'created_at'},
        {text: 'بارکد',align: 'center', value: 'img'},
        {text: 'لیست فرم ها',sortable: false,align: 'center', value: 'download'},
        {text: 'حذف',sortable: false,align: 'center', value: 'remove'},
      ],
      desserts: [],
    },
    barcode_form:{},
    open_forms_name : {name:'', enable:false},
    rules: {
      required: value => !!value || 'اجباری',
      min_3: v => v.length >= 3 || 'حداقل ۳ حرف',
    },
  }),
  methods:{
    manage_download(){
      let url = `${this.BACKEND_LINK}/api/forms/download-${this.report_form.format.toLowerCase()}/?key=${this.key}`;
      if(this.report_form.is_all){
        this.report_form.download_btn_loading=true;
        this.download_file(url,
            `forms.${this.report_form.format.toLowerCase()}`)
      }else {
        if (this.report_form.barcode){
          url+=`&barcode_id=${this.report_form.barcode.id}`
        }
        if (this.report_form.date.length>1){
          url+=`&date=${this.report_form.date}`
        }
        this.download_btn_loading=true;
        this.download_file(url,
            `forms.${this.report_form.format.toLowerCase()}`)
      }
    },
    download_file(url, f_name){
      axios.get(url, { responseType: 'blob'})
          .then(response => {
            const blob = new Blob([response.data], { type: `application/${f_name === 'forms.pdf'?'pdf':'csv'}` })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = f_name
            link.click()
            URL.revokeObjectURL(link.href)
            this.$snotify.success( 'فایل گزارشات با موفقیت دانلود شد.','فایل گزارشات',);
          })
          .catch((errors)=>{
            console.log(errors);
            if (errors.response.status === 403){
              this.$snotify.error('شما به این قسمت دسترسی ندارید!','خطا دسترسی',)
            }else{
              this.$snotify.error( 'مشکلی در دانلود فایل ','فایل گزارشات',)
            }
          })
          .finally(()=>{
            this.report_form.download_btn_loading=false;
          })
    },

    remove_barcode(){
      this.remove.loading = true;
      axios
          .delete(`${this.BACKEND_LINK}/api/barcode/${this.remove.form.id}/`)
          .then(()=>{
            this.$snotify.success('با موفقیت حذف شد.');
            this.remove.en = false
            this.get_barcodes();
          })
          .catch((e)=>{
            this.$snotify.error('خطا در دریافت بارکدها.');
          })
          .finally(()=>{
            this.remove.loading = false;
          })
    },
    download(url) {
      const a = document.createElement('a')
      a.href = url
      a.target = "_blank";
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    get_barcodes(){
      this.loading_barcodes = true;
      axios.get(this.BACKEND_LINK + '/api/barcode/?page=' + this.page + `${this.search_field?'&search='+this.search_field:''}`,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.barcodes_count = response.data.count;
        this.barcodes.desserts = response.data.results;
        this.loading_barcodes = false;
      }).catch((e)=>{
        this.$snotify.error('خطا در دریافت بارکدها.');
        this.loading_barcodes = false;
      })
    },
    send_barcode(){
      if(!this.barcode_form.name){
        this.$snotify.error('انتخاب فرم ضروریست!');
      }else {
        const barcode = new FormData();
        barcode.append("name", this.barcode_form.name);
        barcode.append("device_name", this.barcode_form.device_name?this.barcode_form.device_name:'-');

        axios.post(this.BACKEND_LINK + '/api/barcode/',barcode,{
          headers: {'Authorization': `Token ${this.key}`}
        }).then((response)=>{
          this.barcode_form = {};
          this.$snotify.success('بارکد با موفقیت ثبت شد.', 'ثبت بارکد')
          this.get_barcodes();
          this.add_barcode_dialog = false;

        }).catch((e)=>{
          this.$snotify.error('خطا در ثبت بارکد.', 'ثبت بارکد')
        })
      }
    },
    close_list_form(){
      this.open_forms_name = {enable: false}
    },
    list_forms(barcode){
      console.log(barcode)
      this.open_forms_name = {name:barcode.name, barcode_id:barcode.id, enable:true, device_name:barcode.device_name};
    },
  }
}
</script>

<style scoped>

</style>
